export const checkConnectionQuery = `
query checkConnectionQuery {
  checkConnection
}`;

export const findSampleBatchesQuery = `
query findSampleBatches($searchTerm: String!) {
  findSampleBatches(searchTerm: $searchTerm) {
    batchId
    sampleType
    createdTs
  },
}
`;

export const findCryoboxesQuery = `
query findCryoboxesQuery($freezerId: String, $bioBanked: Boolean!, $searchTerm: String, $offset: Int, $limit: Int) {
  findCryoboxes(freezerId: $freezerId, bioBanked: $bioBanked, searchTerm: $searchTerm, offset: $offset, limit: $limit) {
    data { 
      aliquotPositions
      aliquotPositionTimestamps
      barcodePositions
      barcodeLinkTimestamps
      bioBanked
      createdBy
      createdTs
      freezerShelfNo
      height
      lastUpdatedBy
      rackPositionNo
      sampleType
      serialNo
      locked
      cryoboxUuid
      cryoboxBarcode
      shelfRackNo
      updatedTs
      width
      freezer {
        freezerId
        name
        serialNo
        temp
      }
    }
    count
  },
}
`;

export const getSampleBatchQuery = `
query getSampleBatch($batchID: String!) {
  getSampleBatch(batchID: $batchID) {
    batchId
    createdBy
    createdTs
    lastUpdatedBy
    sampleType
    samples {
      aliquots {
        barcode
        createdBy
        volume
        updatedTs
        status
        sampleBatchId
        sampleBarcode
        mismatch
        lastUpdatedBy
        createdTs
      }
      volume
      status
      barcode
    }
    updatedTs
  },
}
`;

export const getCryoboxQuery = `
query getCryobox($cryoboxUuid: String!) {
  getCryobox(cryoboxUuid: $cryoboxUuid) {
    aliquotPositions
    aliquotPositionTimestamps
    bioBanked
    createdBy
    createdTs
    cryoboxBarcode
    cryoboxUuid
    freezer {
      freezerId
      name
      serialNo
      temp
    }
    freezerShelfNo
    height
    lastUpdatedBy
    rackPositionNo
    sampleType
    serialNo
    shelfRackNo
    updatedTs
    width
  },
}
`;

export const listFreezersQuery = `
query listFreezers {
  listFreezers {
    freezerId
    name
    serialNo
    temp
  }
}
`;

export const getSampleExportStatusQuery = `
query getSampleExportStatusQuery {
  getSampleExportStatus {
    createdTs
    exportLink
    jobError
    jobStatus
    runId
    updatedTs
  }
}`;

export const listAliquotLocationsQuery = `
query listAliquotLocationsQuery {
  listAliquotLocations {
    aliquot_location_uuid
    location
    description
  }
}`;

export const getStagedShipmentMetaQuery = `
query getStagedShipmentMetaQuery {
  getStagedShipmentMeta {
    plannedShipmentDate
    destinationLocation
    destinationLocationUuid
    shipmentType
  }
}`;

export const getStagedShipmentQuery = `
query getStagedShipmentQuery {
  getStagedShipment {
    cryoboxes {
      serialNo
      aliquotCount
      freezer {
        freezerId
        serialNo
        name
        temp
      }
      freezerShelfNo
      shelfRackNo
      rackPositionNo
      cryoboxUuid
      cryoboxBarcode
      eligible
      eligibleCount
      ineligibleCount
    }
    totalAliquotCount
    plannedShipmentDate
    shipmentType
  }
}`;

export const getRankedCryoboxesQuery = `
query getRankedCryoboxesQuery {
  getRankedCryoboxes {
    cryoboxUuid
    serialNo
    eligible
    eligibleCount
    ineligibleCount
    freezerName
    freezerShelfNo
    shelfRackNo
    rackPositionNo
    rank
    sampleType
  }
}`;

export const getStagingPickListQuery = `
query getStagingPickListQuery {
  getStagingPickList {
    cryoboxUuid
    aliquotUuid
    aliquotBarcode
    aliquotPosition
    cryoboxSerialNo
    cryoboxBarcode
    freezerName
    freezerShelfNo
    freezerShelfRackNo
    freezerRackPositionNo
    reason
    eligible
    shippable
  }
}`;

export const listShipmentsQuery = `
query listShipmentsQuery {
  listShipments {
    shipmentId
    displayId
    shipmentType
    source
    destination
    status
    manifestDate
    shippedDate
    cryoboxes {
      serialNo
      aliquotCount
      freezer {
        freezerId
        serialNo
        name
        temp
      }
      freezerShelfNo
      shelfRackNo
      rackPositionNo
      cryoboxUuid
      cryoboxBarcode
    }
    totalAliquotCount
    plannedShipmentDate
    createdTs
  }
}`;

export const getShipmentQuery = `
query getShipment($shipmentId: String!) {
  getShipment(shipmentId: $shipmentId) {
    shipmentId
    displayId
    shipmentType
    source
    destination
    status
    manifestDate
    shippedDate
    cryoboxes {
      serialNo
      aliquotCount
      freezer {
        freezerId
        serialNo
        name
        temp
      }
      freezerShelfNo
      shelfRackNo
      rackPositionNo
      cryoboxUuid
      cryoboxBarcode
      sampleType
    }
    totalAliquotCount
    plannedShipmentDate
  },
}
`;

export const getShipmentManifestQuery = `
query getShipmentManifestQuery($shipmentId: String!) {
  getShipmentManifest(shipmentId: $shipmentId) {
    link
  }
}`;
